import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-module-header',
  templateUrl: './module-header.component.html',
  styleUrls: ['./module-header.component.css']
})
export class ModuleHeaderComponent implements OnInit {

    @Input() label: string;
    @Input() icon: string;
    today: number;

    constructor() { }

    ngOnInit() {
        this.today = Date.now();
    }

}
